import { baseEnvironment } from './environment.base';
import type { Environment } from './environment.model';

export const environment: Environment = {
  ...baseEnvironment,
  production: false,
  apiUrl: 'https://wa-hbox-connect-api-dev-hbgwh3bydkfthndg.australiaeast-01.azurewebsites.net',
};
